import Above from "core-web/components/Breakpoints/Above";
import AccordionItem from "theme/components/accordions/AccordionItem";
import Below from "core-web/components/Breakpoints/Below";
import Column from "theme/layouts/Column";
import Div from "theme/layouts/Div";
import TextLink from "theme/components/text/TextLink";
import TextStyles from "theme/components/text/TextStyles";
import colors from "theme/config/colors";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const SocialMedia = () => {
    const { t } = useTranslation();
    const socialMedia = useSelector(({ footer }) => footer.data?.social_media) || [];

    if (!socialMedia?.length) {
        return null;
    }

    return (
        <>
            <Below
                breakpoint="tabletLg"
                render={() => (
                    <AccordionItem
                        label={t("footer.heading.socials")}
                        typography="Myriad Pro/18-100-semibold-semiextended"
                        activeBorderColor={colors.white}
                        labelColor={colors.white}
                    >
                        <Column as="ul">
                            {socialMedia.map(({ link }) => (
                                <li key={`${link?.url}-${link.text}`}>
                                    <TextLink to={link?.url} py="8px">
                                        {link?.text}
                                    </TextLink>
                                </li>
                            ))}
                        </Column>
                    </AccordionItem>
                )}
            />
            <Above
                breakpoint="tabletLg"
                render={() => (
                    <Column as="article" width="100%" gap="12px">
                        <TextStyles as="h2" textStyles="Myriad Pro/18-100-semibold-semiextended">
                            {t("footer.heading.socials")}
                        </TextStyles>

                        <Column as="ul">
                            {socialMedia.map(({ link }) => (
                                <Div as="li" key={`${link?.url}-${link.text}`} py="8px">
                                    <TextLink to={link?.url}>{link?.text}</TextLink>
                                </Div>
                            ))}
                        </Column>
                    </Column>
                )}
            />
        </>
    );
};

export default SocialMedia;
